export default {
    type: 'Type',
    'bond-no': 'Bond No.',
    'start-date': 'Start date',
    'end-date': 'End date',
    'bond-status': 'Bond status',
    'refresh': 'Refresh',
    all: 'All',
    'posted': 'Posted',
    'non-posted': 'Non posted',
    'cash': 'Cash',
    'accounting': 'Accounting',
    'total-count': 'Total count:',
    'non-posted-bonds-count': 'Non posted bonds count:',
    'delete-bond': 'Delete row',
    'do-you-want-to-delete-$-bond-with-no-$': 'Do you want to delete {type} bond with No. {no}',

    'right-click-menu-items': {
        'go-to-the-journal': 'Go to journal',
        delete: 'Delete',
    },

    headers: {
        'serial': 'Serial',
        'bond-no': 'Bond No.',
        'type': 'Type',
        'status': 'Status',
        'date': 'Date',
    }
}